import { Card } from "@/shared/components/ui/card";
import { Skeleton } from "@/shared/components/ui/skeleton";

function DashboardSectionSkeleton() {
  return (
    <Card className="overflow-hidden border-border/60">
      <div className="flex flex-col gap-4 border-b px-6 py-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-2">
          <Skeleton className="h-7 w-36" />
          <Skeleton className="h-4 w-40" />
        </div>
        <div className="flex gap-3">
          <Skeleton className="h-9 w-48 rounded-xl" />
          <Skeleton className="h-9 w-32 rounded-xl" />
          <Skeleton className="h-9 w-20 rounded-xl" />
        </div>
      </div>
      <div className="space-y-4 p-6">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </Card>
  );
}

export function DashboardSkeleton({
  hasTemplateBuilder,
}: {
  hasTemplateBuilder: boolean;
}) {
  return (
    <div className="space-y-8">
      <div
        className={`grid gap-4 sm:grid-cols-2 ${hasTemplateBuilder ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}
      >
        <Skeleton className="h-28 rounded-3xl" />
        {hasTemplateBuilder ? <Skeleton className="h-28 rounded-3xl" /> : null}
        <Skeleton className="h-28 rounded-3xl" />
        <Skeleton className="h-28 rounded-3xl" />
      </div>

      <DashboardSectionSkeleton />
      {hasTemplateBuilder ? <DashboardSectionSkeleton /> : null}
      <DashboardSectionSkeleton />
      <DashboardSectionSkeleton />
    </div>
  );
}
